import * as TypeGraphQL from "type-graphql";
export var OptionType;
(function (OptionType) {
    OptionType["CALL"] = "CALL";
    OptionType["PUT"] = "PUT";
})(OptionType || (OptionType = {}));
TypeGraphQL.registerEnumType(OptionType, {
    name: "OptionType",
    description: undefined,
});
//# sourceMappingURL=OptionType.js.map